/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */

import React from 'react';
import PropTypes from 'prop-types';
import ListicleStory from '../listicle-story';
import LiveBlogStory from '../live-blog';
import PhotoStory from '../photo-story';
import TextStory from '../text-story';
import VideoStory from '../video-story';

import { CUSTOM_STORY_ATTRIBUTE, findStoryTemplate } from '../../../component-bundles/bundling-utils';
import EventStory from '../event-story';
import { isEventCustomTemplateSupported } from '../util';

export const CustomStory = props => {
  const { storyPageType, storyBaseType, storyTemplate } = findStoryTemplate(props);
  const allProps = { ...props, storyStoreField: CUSTOM_STORY_ATTRIBUTE, storyPageType, storyBaseType };
  const displayEventsStoryTemplate = isEventCustomTemplateSupported(props?.story, props?.config);

  if (displayEventsStoryTemplate) {
    return <EventStory {...allProps} />;
  }

  // `storyTemplate` is used a fallback because non-PB publishers will have `storyBaseType` as empty
  switch (storyBaseType || storyTemplate) {
    case 'photo':
      return <PhotoStory {...allProps} />;
    case 'video':
      return <VideoStory {...allProps} />;
    case 'listicle':
      return <ListicleStory {...allProps} />;
    case 'live-blog':
      return <LiveBlogStory {...allProps} />;
    case 'text':
    default:
      return <TextStory {...allProps} />;
  }
};
CustomStory.propTypes = {
  config: PropTypes.object,
  story: PropTypes.object
};

export default CustomStory;
